import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { v4 as uuid } from "uuid";
import { ImageCropper } from "Components/Modal";
import { Validator } from "../../Utils/validator";
import useAuth from "../../Context/useAuth";
import {
  GET_DOCUMENTS_URL,
  GET_EDUCATION_DETAILS_URL,
  GET_EXTRACARICULAM_URL,
  GET_PUBLICATION_URL,
  UPDATE_DOCUMENTS_URL,
  UPDATE_EDUCATION_DETAILS_URL,
  UPDATE_EXTRACARICULAM_URL,
  UPDATE_PUBLICATION_URL,
  UPDATE_USERINFO_URL,
} from "../../Constant/api";
import { authService, newAuthService } from "../../Service/Axios";
import { Tab, Tabs } from "react-bootstrap";
import {
  DEFAULT_DOCUMENT_TYPE,
  DEFAULT_MODULE_TYPE,
  DOCUMENT_TYPE_PDF_ONLY,
  IMAGE_TYPES,
} from "../../Constant/constants";
import {
  formatDateWithFullMonth,
  getFirstLetterOfName,
  handleAlphabets,
  uploadHandler,
} from "../../Utils";
import { paths } from "../../Constant/paths";
import { useAccountSettingMenuList } from "../../Constant/apiHooks";

export default function AccountSetting() {
  const { t } = useTranslation();
  const { user, updateUser, Logout } = useAuth();

  const [loading, setLoading] = useState(false);
  const [imageCropModal, setImageCropModal] = useState(false);
  const [imageCropPath, setCropImagePath] = useState("");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    contactNo: "",
    contactNo: "",
    address: "",
  });

  const defaultEducationDetails = {
    id: uuid(),
    gid: "",
    collegeName: "",
    major: "",
    degreeType: "",
    graduationDate: "",
    startDate: "",
    endDate: "",
    gpa: "",
    scale: "",
  };
  const [educationDetails, setEducationDetails] = useState([
    defaultEducationDetails,
  ]);

  const defaultPublicationDetails = {
    id: uuid(),
    gid: "",
    type: "",
    name: "",
    url: "",
    details: "",
  };
  const [publicationDetails, setPublicationDetails] = useState([
    defaultPublicationDetails,
  ]);

  const defaultExtraCariculam = {
    id: uuid(),
    gid: "",
    name: "",
    description: "",
  };
  const [extraCariculamDetails, setExtraCariculamDetails] = useState([
    defaultExtraCariculam,
  ]);

  const defaultDocuments = {
    id: uuid(),
    gid: "",
    name: "",
    type: "",
    files: {
      gid: null,
      url: "",
    },
  };
  const [documentsDetails, setDocumentsDetails] = useState([defaultDocuments]);

  const { firstName, lastName, email, contactNo, address } = formData;

  const [errMsg, setErrMsg] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const { accountSettingMenuList } = useAccountSettingMenuList();

  const filteredMenuList = useMemo(() => {
    const defaultOptions = [
      {
        key: "accountSetting",
        href: paths.common.accountSetting,
        icon: "bx bx-cog",
        label: t("common.button.accountSetting"),
      },
      {
        key: "buildPortfolio",
        href: paths.admin.dashboard,
        icon: "bx bx-user-circle",
        label: t("common.button.buildPortfolio"),
      },
      {
        key: "inviteMember",
        href: paths.common.inviteMember,
        icon: "bx bx-user-plus",
        label: t("common.button.inviteMember"),
      },
      {
        key: "securityAndPrivacy",
        href: paths.admin.dashboard,
        icon: "bx bx-shield-quarter",
        label: t("common.button.securityAndPrivacy"),
      },
      {
        key: "language",
        href: paths.admin.dashboard,
        icon: "bx bx-globe",
        label: t("common.button.language"),
      },
      {
        key: "documents",
        href: paths.admin.dashboard,
        icon: "bx bxs-layer",
        label: t("common.button.documents"),
      },
      {
        key: "changeTheme",
        href: paths.admin.dashboard,
        icon: "bx bxs-layer",
        label: t("common.button.changeTheme"),
      },
    ];
    return defaultOptions.filter((option) =>
      accountSettingMenuList.includes(option.key)
    );
  }, [accountSettingMenuList]);

  // Listing
  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        ...prev,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.userId,
        contactNo: user.contactno,
        address: user.address,
      }));
    }
  }, [user]);

  const getEducationDetails = async () => {
    const payload = {};
    const response = await authService(
      GET_EDUCATION_DETAILS_URL,
      "POST",
      payload
    );
    setEducationDetails(response);
  };
  const getPublicationDetails = async () => {
    const payload = {};
    const response = await authService(GET_PUBLICATION_URL, "POST", payload);
    setPublicationDetails(response);
  };
  const getExtraCariculamDetails = async () => {
    const payload = {};
    const response = await authService(GET_EXTRACARICULAM_URL, "POST", payload);
    setExtraCariculamDetails(response);
  };
  const getDocumentsDetails = async () => {
    const payload = {};
    const response = await authService(GET_DOCUMENTS_URL, "POST", payload);
    setDocumentsDetails(response);
  };

  useEffect(() => {
    getEducationDetails();
    getPublicationDetails();
    getExtraCariculamDetails();
    getDocumentsDetails();
  }, []);

  // Toggle
  const toggleImageCropModal = () => {
    setImageCropModal(!imageCropModal);
  };

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (e.target.name === "firstName") {
      if (!e.target.value) {
        setErrMsg((prev) => ({
          ...prev,
          firstName: t("common.messages.error.common.firstName.blank"),
        }));
      } else if (e.target.value && !Validator.name(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          firstName: t("common.messages.error.common.firstName.inValid"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          firstName: "",
        }));
      }
    }
    if (e.target.name === "lastName") {
      if (!e.target.value) {
        setErrMsg((prev) => ({
          ...prev,
          lastName: t("common.messages.error.common.lastName.blank"),
        }));
      } else if (e.target.value && !Validator.name(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          lastName: t("common.messages.error.common.lastName.inValid"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          lastName: "",
        }));
      }
    }
    if (e.target.name === "email") {
      if (!e.target.value) {
        setErrMsg((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.blank"),
        }));
      } else if (e.target.value && !Validator.email(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.inValid"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          email: "",
        }));
      }
    }
  };

  // Profile Picture
  const handleProfilePictureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCropImagePath(reader.result);
        toggleImageCropModal();
      };
      reader.readAsDataURL(file);
    }
  };

  const onSaveProfilePicture = async (e, cropFile) => {
    const mockEvent = {
      target: {
        files: [cropFile],
      },
    };
    const response = await uploadHandler(
      mockEvent,
      DEFAULT_MODULE_TYPE.profilePicture,
      IMAGE_TYPES
    );
    if (response && response.url) {
      onUserInfoUpdate(e, response.url);
    }
  };

  // User Info
  const getValidation = () => {
    return new Promise((resolve) => {
      if (
        firstName &&
        Validator.name(firstName) &&
        lastName &&
        Validator.name(lastName) &&
        email &&
        Validator.email(email)
      ) {
        resolve(true);
      } else {
        if (!firstName) {
          setErrMsg((prev) => ({
            ...prev,
            firstName: t("common.messages.error.common.firstName.blank"),
          }));
        } else if (firstName && !Validator.name(firstName)) {
          setErrMsg((prev) => ({
            ...prev,
            firstName: t("common.messages.error.common.firstName.inValid"),
          }));
        }

        if (!lastName) {
          setErrMsg((prev) => ({
            ...prev,
            lastName: t("common.messages.error.common.lastName.blank"),
          }));
        } else if (lastName && !Validator.name(lastName)) {
          setErrMsg((prev) => ({
            ...prev,
            lastName: t("common.messages.error.common.lastName.inValid"),
          }));
        }

        if (!email) {
          setErrMsg((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.blank"),
          }));
        } else if (email && !Validator.email(email)) {
          setErrMsg((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.inValid"),
          }));
        }
        resolve(false);
      }
    });
  };

  // Education
  const addMoreEducationDetails = () => {
    setEducationDetails([...educationDetails, defaultEducationDetails]);
  };

  const deleteEducationDetails = async (id) => {
    const deletedArr = educationDetails.filter((e) => e.id !== id);
    setEducationDetails(deletedArr);
    const response = await authService(
      UPDATE_EDUCATION_DETAILS_URL,
      "POST",
      deletedArr
    );
    if (response) {
      getEducationDetails();
    }
  };

  const handleChangeEducationDetails = (e, index) => {
    const newArr = [...educationDetails];
    newArr[index][e.target.name] = e.target.value;
    setEducationDetails(newArr);
  };

  // Publication
  const addMorePublicationDetails = () => {
    setPublicationDetails([...publicationDetails, defaultPublicationDetails]);
  };

  const deletePublicationDetails = async (id) => {
    const deletedArr = publicationDetails.filter((e) => e.id !== id);
    setPublicationDetails(deletedArr);
    const response = await authService(
      UPDATE_PUBLICATION_URL,
      "POST",
      deletedArr
    );
    if (response) {
      getPublicationDetails();
    }
  };

  const handleChangePublicationDetails = (e, index) => {
    const newArr = [...publicationDetails];
    newArr[index][e.target.name] = e.target.value;
    setPublicationDetails(newArr);
  };

  // Extra Cariculam
  const addMoreExtraCariculamDetails = () => {
    setExtraCariculamDetails([...extraCariculamDetails, defaultExtraCariculam]);
  };

  const deleteExtraCariculamDetails = async (id) => {
    const deletedArr = extraCariculamDetails.filter((e) => e.id !== id);
    setExtraCariculamDetails(deletedArr);
    const response = await authService(
      UPDATE_EXTRACARICULAM_URL,
      "POST",
      deletedArr
    );
    if (response) {
      getExtraCariculamDetails();
    }
  };

  const handleChangeExtraCariculamDetails = (e, index) => {
    const newArr = [...extraCariculamDetails];
    newArr[index][e.target.name] = e.target.value;
    setExtraCariculamDetails(newArr);
  };

  // Documents
  const addMoreDocumentsDetails = () => {
    setDocumentsDetails([...documentsDetails, defaultDocuments]);
  };

  const deleteDocumentsDetails = async (id) => {
    const deletedArr = documentsDetails.filter((e) => e.id !== id);
    setDocumentsDetails(deletedArr);
    const response = await authService(
      UPDATE_DOCUMENTS_URL,
      "POST",
      deletedArr
    );
    if (response) {
      getDocumentsDetails();
    }
  };

  const removeDocument = (index) => {
    const newArr = [...documentsDetails];
    newArr[index].files = null;
    setDocumentsDetails(newArr);
  };

  const handleChangeDocumentsDetails = async (e, index) => {
    const newArr = [...documentsDetails];
    if (e.target.name === "files") {
      const response = await uploadHandler(
        e,
        DEFAULT_MODULE_TYPE.portfolioDocument,
        DOCUMENT_TYPE_PDF_ONLY
      );
      newArr[index][e.target.name] = response;
    } else {
      newArr[index][e.target.name] = e.target.value;
    }
    setDocumentsDetails(newArr);
  };

  // Submit
  const onUserInfoUpdate = async (e, photoURL) => {
    e.preventDefault();
    const validationStatus = await getValidation();
    if (validationStatus) {
      const payload = {
        firstName,
        lastName,
        contactno: contactNo,
        address,
      };
      if (photoURL) {
        payload.photoURL = photoURL;
      }
      const response = await authService(UPDATE_USERINFO_URL, "POST", payload);
      if (response) {
        const updatedUser = {
          ...user,
          ...payload,
        };
        updateUser(updatedUser);
      }
    }
  };

  const onUpdateEducationDetails = async (e) => {
    e.preventDefault();
    const response = await newAuthService(
      UPDATE_EDUCATION_DETAILS_URL,
      "POST",
      educationDetails
    );
    if (response.status) {
      getEducationDetails();
    }
  };

  const onUpdatePublicationDetails = async (e) => {
    e.preventDefault();
    const response = await newAuthService(
      UPDATE_PUBLICATION_URL,
      "POST",
      publicationDetails
    );
    if (response.status) {
      getPublicationDetails();
    }
  };

  const onUpdateExtraCariculamDetails = async (e) => {
    e.preventDefault();
    const response = await newAuthService(
      UPDATE_EXTRACARICULAM_URL,
      "POST",
      extraCariculamDetails
    );
    if (response.status) {
      getExtraCariculamDetails();
    }
  };

  const onUpdateDocumentsDetails = async (e) => {
    e.preventDefault();
    const response = await newAuthService(
      UPDATE_DOCUMENTS_URL,
      "POST",
      documentsDetails
    );
    if (response.status) {
      getDocumentsDetails();
    }
  };

  return (
    <main className="main">
      <div className="px-6 py-8 bg-transparent profile-update-box">
        <div className="row gy-4 position-relative">
          <div className="col-xxl-3 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="profile-sidebar bg-white p-4 rounded-3 h-100">
              {user && (
                <div className="profile-header text-center">
                  <h3 className="user-name">
                    {user.firstName} {user.lastName}
                  </h3>
                  <h4 className="user-email">{user.data}</h4>
                  <div className="profile-img-group mt-3">
                    <button className="profile-edit-btn">
                      <input
                        type="file"
                        id="file"
                        onChange={handleProfilePictureChange}
                      />
                      <label htmlFor="file">
                        <i className="bx bxs-pencil"></i>
                      </label>
                    </button>
                    <div className="profile-image">
                      {user.photoURL ? (
                        <img
                          src={user.photoURL}
                          alt={`${user.firstName}${user.lastName}`}
                        />
                      ) : (
                        getFirstLetterOfName(user)
                      )}
                    </div>
                  </div>
                  <div className="d-grid my-3 dropdown-logout">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={Logout}
                    >
                      {t("common.button.signOut")}
                    </button>
                  </div>
                </div>
              )}
              <ul className="dropdown-menu d-block">
                {filteredMenuList.map((menu) => (
                  <li key={menu.key}>
                    <Link className="dropdown-item" to={menu.href}>
                      <i className={menu.icon}></i> {menu.label}
                    </Link>
                  </li>
                ))}
                {/* <li>
                  <Link
                    className="dropdown-item"
                    to={paths.common.accountSetting}
                  >
                    <i className="bx bx-cog"></i>{" "}
                    {t("common.button.accountSetting")}
                  </Link>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    <i className="bx bx-user-circle"></i>{" "}
                    {t("common.button.buildPortfolio")}
                  </a>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to={paths.common.inviteMember}
                  >
                    <i className="bx bx-user-plus"></i>{" "}
                    {t("common.button.inviteMember")}
                  </Link>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    <i className="bx bx-shield-quarter"></i>{" "}
                    {t("common.button.securityAndPrivacy")}
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    <i className="bx bx-globe"></i>{" "}
                    {t("common.button.language")}
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    <i className="bx bxs-layer"></i>{" "}
                    {t("common.button.documents")}
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    <i className="bx bx-adjust"></i>{" "}
                    {t("common.button.changeTheme")}
                  </a>
                </li> */}
              </ul>
              <div className="profile-footer text-center mt-4">
                <p className="member-since">
                  {t("auth.accountSettings.memberSince")}:{" "}
                  {user.createdOn && formatDateWithFullMonth(user.createdOn)}
                </p>
              </div>
            </div>
          </div>
          <div className="col-xxl-9 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="profile-editbar h-100 p-4 rounded-3 bg-white">
              <div className="profile-edit-header">
                <h3 className="edit-title">
                  {t("auth.accountSettings.editPortfolio")}
                </h3>
              </div>

              <div className="tab-nav">
                <Tabs defaultActiveKey="userInfo" className="nav-underline">
                  <Tab eventKey="userInfo" title="User Info" className="py-4">
                    <form
                      className="from-box from-box-lg"
                      onSubmit={onUserInfoUpdate}
                    >
                      <div className="row">
                        <div className="col-md-6 col-sm-12 col-12">
                          <div className="mb-4">
                            <label htmlFor="firstName" className="form-label">
                              {t("common.label.firstName")}
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              id="firstName"
                              name="firstName"
                              value={firstName || ""}
                              onChange={handleChange}
                              onKeyDown={handleAlphabets}
                            />{" "}
                            {errMsg.firstName && (
                              <p className="error">{errMsg.firstName}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12 col-12">
                          <div className="mb-4">
                            <label htmlFor="last" className="form-label">
                              {t("common.label.lastName")}
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              id="lastName"
                              name="lastName"
                              value={lastName || ""}
                              onChange={handleChange}
                              onKeyDown={handleAlphabets}
                            />{" "}
                            {errMsg.lastName && (
                              <p className="error">{errMsg.lastName}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12 col-12">
                          <div className="mb-4">
                            <label htmlFor="email" className="form-label">
                              {t("common.label.email")}
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              id="email"
                              name="email"
                              value={email || ""}
                              onChange={handleChange}
                              disabled
                            />{" "}
                            {errMsg.email && (
                              <p className="error">{errMsg.email}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12 col-12">
                          <div className="mb-4">
                            <label htmlFor="contactNo" className="form-label">
                              {t("common.label.contactNo")}
                            </label>
                            <input
                              type="tel"
                              className="form-control form-control-lg"
                              id="contactNo"
                              name="contactNo"
                              value={contactNo || ""}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12 col-12">
                          <div className="mb-4">
                            <label htmlFor="address" className="form-label">
                              {t("common.label.address")}
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              id="address"
                              name="address"
                              value={address || ""}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12 col-12">
                          <button
                            type="submit"
                            className="btn btn-primary btn-lg"
                          >
                            {t("common.button.update")}
                          </button>
                        </div>
                      </div>
                    </form>
                  </Tab>

                  <Tab
                    eventKey="educationDetails"
                    title="Education History"
                    className="py-4"
                  >
                    <div className="text-end">
                      <button
                        className="btn btn-tranparent"
                        onClick={addMoreEducationDetails}
                        disabled={educationDetails.length === 3}
                      >
                        <i className="bx bx-plus"></i>{" "}
                        {t("common.button.addMore")}
                      </button>
                    </div>
                    {educationDetails &&
                      educationDetails.length > 0 &&
                      educationDetails.map((edu, index) => (
                        <form
                          className="from-box from-box-lg"
                          onSubmit={onUpdateEducationDetails}
                          key={edu.id}
                        >
                          <div className="row">
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="collegeName"
                                  className="form-label"
                                >
                                  {t("common.label.collegeName")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="collegeName"
                                  name="collegeName"
                                  value={edu.collegeName || ""}
                                  onChange={(e) =>
                                    handleChangeEducationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label htmlFor="major" className="form-label">
                                  {t("common.label.major")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="major"
                                  name="major"
                                  value={edu.major || ""}
                                  onChange={(e) =>
                                    handleChangeEducationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="degreeType"
                                  className="form-label"
                                >
                                  {t("common.label.degree")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="degreeType"
                                  name="degreeType"
                                  value={edu.degreeType || ""}
                                  onChange={(e) =>
                                    handleChangeEducationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="graduationDate"
                                  className="form-label"
                                >
                                  {t("common.label.graduationDate")}
                                </label>
                                <input
                                  type="date"
                                  className="form-control form-control-lg"
                                  id="graduationDate"
                                  name="graduationDate"
                                  value={edu.graduationDate || ""}
                                  onChange={(e) =>
                                    handleChangeEducationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="startDate"
                                  className="form-label"
                                >
                                  {t("common.label.startDate")}
                                </label>
                                <input
                                  type="date"
                                  className="form-control form-control-lg"
                                  id="startDate"
                                  name="startDate"
                                  value={edu.startDate || ""}
                                  onChange={(e) =>
                                    handleChangeEducationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label htmlFor="endDate" className="form-label">
                                  {t("common.label.endDate")}
                                </label>
                                <input
                                  type="date"
                                  className="form-control form-control-lg"
                                  id="endDate"
                                  name="endDate"
                                  value={edu.endDate || ""}
                                  onChange={(e) =>
                                    handleChangeEducationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label htmlFor="gpa" className="form-label">
                                  {t("common.label.gpa")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="gpa"
                                  name="gpa"
                                  value={edu.gpa || ""}
                                  onChange={(e) =>
                                    handleChangeEducationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label htmlFor="scale" className="form-label">
                                  {t("common.label.scale")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="scale"
                                  name="scale"
                                  value={edu.scale || ""}
                                  onChange={(e) =>
                                    handleChangeEducationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-12">
                              <button
                                type="submit"
                                className="btn btn-primary btn-lg"
                              >
                                {t("common.button.update")}
                              </button>
                              <button
                                className="btn btn-transparent btn-lg"
                                onClick={() => deleteEducationDetails(edu.id)}
                              >
                                {t("common.button.delete")}
                              </button>
                            </div>
                          </div>
                        </form>
                      ))}
                  </Tab>

                  <Tab
                    eventKey="publication"
                    title="Publication"
                    className="py-4"
                  >
                    <div className="text-end">
                      <button
                        className="btn btn-transparent"
                        onClick={addMorePublicationDetails}
                      >
                        <i className="bx bx-plus"></i>{" "}
                        {t("common.button.addMore")}
                      </button>
                    </div>
                    {publicationDetails &&
                      publicationDetails.length > 0 &&
                      publicationDetails.map((pub, index) => (
                        <form
                          className="from-box from-box-lg"
                          onSubmit={onUpdatePublicationDetails}
                          key={pub.id}
                        >
                          <div className="row">
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="publicationName"
                                  className="form-label"
                                >
                                  {t("common.label.publicationName")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="publicationName"
                                  name="name"
                                  value={pub.name || ""}
                                  onChange={(e) =>
                                    handleChangePublicationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="publicationType"
                                  className="form-label"
                                >
                                  {t("common.label.publicationType")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="publicationType"
                                  name="type"
                                  value={pub.type || ""}
                                  onChange={(e) =>
                                    handleChangePublicationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="publicationUrl"
                                  className="form-label"
                                >
                                  {t("common.label.publicationUrl")}
                                </label>
                                <input
                                  type="url"
                                  className="form-control form-control-lg"
                                  id="publicationUrl"
                                  name="url"
                                  value={pub.url || ""}
                                  onChange={(e) =>
                                    handleChangePublicationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="publicationDetails"
                                  className="form-label"
                                >
                                  {t("common.label.publicationDetails")}
                                </label>
                                <textarea
                                  className="form-control form-control-lg"
                                  id="publicationDetails"
                                  name="details"
                                  value={pub.details}
                                  onChange={(e) =>
                                    handleChangePublicationDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-12">
                              <button
                                type="submit"
                                className="btn btn-primary btn-lg"
                              >
                                {t("common.button.update")}
                              </button>
                              <button
                                className="btn btn-transparent btn-lg"
                                onClick={() => deletePublicationDetails(pub.id)}
                              >
                                {t("common.button.delete")}
                              </button>
                            </div>
                          </div>
                        </form>
                      ))}
                  </Tab>

                  <Tab
                    eventKey="extraCariculam"
                    title="Extracurricular"
                    className="py-4"
                  >
                    <div className="text-end">
                      <button
                        className="btn btn-transparent btn-lg"
                        onClick={addMoreExtraCariculamDetails}
                      >
                        <i className="bx bx-plus"></i>{" "}
                        {t("common.button.addMore")}
                      </button>
                    </div>
                    {extraCariculamDetails &&
                      extraCariculamDetails.length > 0 &&
                      extraCariculamDetails.map((ec, index) => (
                        <form
                          className="from-box from-box-lg"
                          onSubmit={onUpdateExtraCariculamDetails}
                          key={ec.id}
                        >
                          <div className="row">
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="activityName"
                                  className="form-label"
                                >
                                  {t("common.label.activityName")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="activityName"
                                  name="name"
                                  value={ec.name || ""}
                                  onChange={(e) =>
                                    handleChangeExtraCariculamDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="publicationDetails"
                                  className="form-label"
                                >
                                  {t("common.label.activityDetails")}
                                </label>
                                <textarea
                                  className="form-control form-control-lg"
                                  id="publicationDetails"
                                  name="description"
                                  value={ec.description}
                                  onChange={(e) =>
                                    handleChangeExtraCariculamDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-12 pb-4">
                              <button
                                type="submit"
                                className="btn btn-primary btn-lg"
                              >
                                {t("common.button.update")}
                              </button>
                              <button
                                className="btn btn-transparent btn-lg"
                                onClick={() =>
                                  deleteExtraCariculamDetails(ec.id)
                                }
                              >
                                {t("common.button.delete")}
                              </button>
                            </div>
                          </div>
                        </form>
                      ))}
                  </Tab>

                  <Tab eventKey="Documents" title="Documents" className="py-4">
                    <div className="text-end">
                      <button
                        className="btn btn-tranparent btn-lg"
                        onClick={addMoreDocumentsDetails}
                      >
                        <i className="bx bx-plus"></i>{" "}
                        {t("common.button.addMore")}
                      </button>
                    </div>
                    {documentsDetails &&
                      documentsDetails.length > 0 &&
                      documentsDetails.map((doc, index) => (
                        <form
                          className="from-box from-box-lg"
                          onSubmit={onUpdateDocumentsDetails}
                          key={doc.id}
                        >
                          <div className="row">
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="documenName"
                                  className="form-label"
                                >
                                  {t("common.label.documentName")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="documenName"
                                  name="name"
                                  value={doc.name || ""}
                                  onChange={(e) =>
                                    handleChangeDocumentsDetails(e, index)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="documentType"
                                  className="form-label"
                                >
                                  {t("common.label.documentType")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="documentType"
                                  name="type"
                                  value={doc.type || ""}
                                  onChange={(e) =>
                                    handleChangeDocumentsDetails(e, index)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-12 col-sm-12 col-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="documentType"
                                  className="form-label"
                                >
                                  <span className="material-symbols-outlined align-middle">
                                    upload_file
                                  </span>{" "}
                                  {t("common.label.uploadDocument")}
                                </label>
                                {doc.files?.name ? (
                                  <div className="d-flex align-items-center">
                                    <span className="text-sm">
                                      {doc.files?.name}
                                    </span>
                                    <div className="ms-auto">
                                      <a
                                        href={doc.files?.url}
                                        target="_blank"
                                        className="btn btn-gray-light btn-sm"
                                      >
                                        <i className="bx bx-show-alt bx-xs"></i>
                                      </a>
                                      <Button
                                        variant="gray-light btn-sm ms-1"
                                        onClick={() => removeDocument(index)}
                                      >
                                        <i className="bx bx-trash bx-xs"></i>
                                      </Button>
                                    </div>
                                  </div>
                                ) : (
                                  <input
                                    type="file"
                                    className="form-control form-control-lg"
                                    id="documentType"
                                    name="files"
                                    onChange={(e) =>
                                      handleChangeDocumentsDetails(e, index)
                                    }
                                    accept={DEFAULT_DOCUMENT_TYPE.toString()}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-12 pb-4">
                              <button
                                type="submit"
                                className="btn btn-primary btn-lg"
                              >
                                {t("common.button.update")}
                              </button>
                              <button
                                className="btn btn-transparent btn-lg"
                                onClick={() => deleteDocumentsDetails(doc.id)}
                              >
                                {t("common.button.delete")}
                              </button>
                            </div>
                          </div>
                        </form>
                      ))}
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>

      {imageCropModal && (
        <ImageCropper
          show={imageCropModal}
          src={imageCropPath}
          toggle={toggleImageCropModal}
          handleCrop={onSaveProfilePicture}
        />
      )}
    </main>
  );
}
